<script setup lang="ts">
import { useUserStore } from '@/stores/userStore';
import { useI18n } from 'vue-i18n';
import { ref, computed } from 'vue';
import { useBodyScrollLock } from "@/composables/useBodyScrollLock";


const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close']);
const closeDrawer = () => {
  emit('close');
};

const isDrawerOpen = computed(() => props.isOpen);
useBodyScrollLock(isDrawerOpen);


// Reactive state for submenu
const isAboutSubmenuOpen = ref(false);
const toggleAboutSubmenu = () => {
  isAboutSubmenuOpen.value = !isAboutSubmenuOpen.value;
};

const userStore = useUserStore();
const { t } = useI18n();
</script>

<template>
  <div v-if="props.isOpen" class="backdrop" @click="closeDrawer"></div>
  <div :class="['menu-drawer', { open: props.isOpen }]">
    <div class="menu-header justify-end">
      <div class="cursor-pointer btnClose" type="default" @click="closeDrawer">
        <img src="@/assets/icons/svg/Close_16x16.svg" :alt="t('drawer.close')" width="16" />
      </div>
    </div>
    <div class="menu-content">
      <div v-if="!userStore.isLoggedIn">
        <ul>
          <!-- Cosmos Section -->
          <li class="menu-title responsive-title-5 font-bold">{{ t('drawer.cosmos') }}</li>
          <li>
            <RouterLink :to="`/${$i18n.locale}/about`" @click="closeDrawer">
              <span class="responsive-body-medium font-normal"> {{ t('drawer.about') }}</span>
            </RouterLink>
          </li>

          <!-- Other Links -->
          <li>
            <RouterLink :to="`/${$i18n.locale}/why-book`" @click="closeDrawer">
              <span class="responsive-body-medium font-normal">{{ t('drawer.whybookwithus') }}</span>
            </RouterLink>
          </li>
          <li>
            <RouterLink :to="`/${$i18n.locale}/blog`" @click="closeDrawer">
              <span class="responsive-body-medium font-normal">{{ t('drawer.travelInspiration') }}</span>
            </RouterLink>
          </li>

          <hr class="my-2.5"/>

          <!-- Support Section -->
          <li class="menu-title responsive-title-5 font-bold">{{ t('drawer.support') }}</li>
          <li>
            <RouterLink :to="`/${$i18n.locale}/inquiry`" @click="closeDrawer">
              <span class="responsive-body-medium font-normal">{{ t('drawer.inquiry') }}</span>
            </RouterLink>
          </li>
          <li>
            <RouterLink :to="`/${$i18n.locale}/help`" @click="closeDrawer">
              <span class="responsive-body-medium font-normal">{{ t('drawer.help') }}</span>
            </RouterLink>
          </li>
          <li>
            <RouterLink :to="`/${$i18n.locale}/faq`" @click="closeDrawer">
              <span class="responsive-body-medium font-normal">{{ t('drawer.faqs') }}</span>
            </RouterLink>
          </li>
          
        </ul>
      </div>
    </div>

    <!-- Phone Numbers Section -->
    <hr class="my-2.5"/>
    <div class="phone-numbers-section pt-3">
      <div class="flex items-center mb-2.5 gap-x-2">
        <p class="responsive-body-xsmall font-semibold">GER</p>
        <a href="tel:+4989411471900" class="responsive-body-small text-bw-darkGrey hover:text-black text-no-wrap">
          +49 (0)89 411 47 19 00
        </a>
      </div>

      <div class="flex items-center gap-x-4">
        <p class="responsive-body-xsmall font-semibold">UK</p>
        <a href="tel:+442088780880" class=" responsive-body-small text-bw-darkGrey hover:text-black text-no-wrap">
          +44 (0)20 8878 0880
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9000;
  /* Ensure it's below the drawer but above everything else */
  transition: opacity 0.3s ease;
}
.menu-content {
  flex: 1; /* Allow the menu content to grow and take up available space */
  overflow-y: auto;
}

.menu-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 350px;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  z-index: 9999;
  padding: 30px;
  overflow-y: auto;
}


.menu-drawer.open {
  transform: translateX(0);
}

.menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
  background-color: #fff;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

li {
  padding: 0.5rem;
}

a {
  text-decoration: none;
}

button {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}
.btnClose{
  border: 1px solid #B7B6BE;
  padding: 6px 16px;
  border-radius: 20px;
}
@media (max-width:768px) {
  .menu-drawer{
    border-radius: 20px 0 0 20px;
  }
}

.phone-numbers-section {
  padding: 16px 0;
  background-color: white;
  flex-shrink: 0; /* Prevent shrinking */
}

</style>
